import React, { useState, useEffect } from "react";
import { ExternalLink, FileText } from 'lucide-react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import paymentBg from '../../images/paymet_summary-bg.svg';
import pdf from '../../resources/pricing-sheets/NULIFESPANRX-Introduction.Notification_3-27-25.pdf';
import { userService } from "../../_services";
import W9FormStarter from "./W9FormStarter";

function Payments_Summary({ pqKey: pqKeyProp }) {
    const [isNullPQKey, setIsNullPQKey] = useState(false);
    const [pqInKey, setPqInKey] = useState('');
    const [isInitiatingPayment, setIsInitiatingPayment] = useState(false);
    const [openStarterForm, setOpenStarterForm] = useState(false);

    useEffect(() => {
        if (pqKeyProp === "") {
            setIsNullPQKey(true);
            setPqInKey('');
        } else {
            setIsNullPQKey(false);
            setPqInKey(pqKeyProp);
        }
    }, [pqKeyProp]);

    const initiatePQ = () => {
        const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        setIsInitiatingPayment(true);
        setTimeout(() => {
            makepqInvite(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
        }, 100);
    };

    const makepqInvite = (UserId, UserName) => {
        try {
            userService.pqInvite(UserId, UserName).then(apidata => {
                if (apidata.length > 0) {
                    if (apidata[0].code == "1") {
                        setIsNullPQKey(false);
                        setPqInKey(apidata[0].message);
                        window.open('https://nulifespanrx.mypayquicker.com/Welcome?InvitationId=' + apidata[0].message, '_blank');
                    } else {
                        setIsInitiatingPayment(false);
                    }
                }
            });
        } catch (error) {
            setIsInitiatingPayment(false);
        }
    };

    const navlink = 'https://nulifespanrx.mypayquicker.com/Welcome?InvitationId=' + pqInKey;

    return (
        <Card
            className="border-0 overflow-hidden"
            style={{
                background: `#313131 url(${paymentBg}) no-repeat center top`,
                backgroundSize: 'auto 153%'
            }}
        >
            <CardContent className="px-4 sm:px-6 py-8 flex flex-col md:flex-row items-start md:items-end gap-6">
                <div className="flex-shrink-0 max-w-[300px]">
                    <h3 className="text-2xl font-black text-white leading-8 mb-3">Payments</h3>
                    <p className="text-2xl text-white leading-7">Making payments is easier now!!</p>
                </div>

                <div className="flex flex-col md:flex-row flex-wrap gap-2 md:ml-auto md:w-[400px] md:items-end">
                    <Button
                        variant="outline"
                        size="default"
                        asChild
                        className="bg-card hover:bg-gray-50 text-primary border-white h-10 min-w-[120px]"
                    >
                        <a href={pdf} target="_blank" rel="noopener noreferrer">
                            <FileText className="h-4 w-4" />
                            How it Works
                        </a>
                    </Button>

                    {!isNullPQKey ? (
                        <Button
                            variant="secondary"
                            size="default"
                            asChild
                            className="h-10 min-w-[140px]"
                        >
                            <a href={navlink} target="_blank" rel="noopener noreferrer">
                                My Payments
                                <ExternalLink className="h-4 w-4" />
                            </a>
                        </Button>
                    ) : (
                        <Button
                            variant="secondary"
                            size="default"
                            onClick={initiatePQ}
                            disabled={isInitiatingPayment}
                            className="h-10"
                            style={{ minWidth: isInitiatingPayment ? 'auto' : '160px' }}
                        >
                            {isInitiatingPayment ? 'Initiating Payment...' : (
                                <>
                                    Initiate Payments
                                    <ExternalLink className="h-4 w-4" />
                                </>
                            )}
                        </Button>
                    )}
                </div>
            </CardContent>
        </Card>
    );
}

export default Payments_Summary;

